module.exports = __webpack_public_path__ + "static/about-img2-219ed5fa2c415c0e17b58ce3b57ea5af.jpeg";